import { render } from "./MovingModal.vue?vue&type=template&id=3204a08a"
import script from "./MovingModal.vue?vue&type=script&lang=js"
export * from "./MovingModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__